// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4EUEh","copy":"styles_copy__OjqoZ"};